import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Services
import { RecordsService } from '@modules/records/services/records.service';
import { NotificationService } from '@modules/elements/services/notification.service';

// Types
import { RecordTask, RecordTaskStatus } from '@modules/records/types/record';

interface TaskNeed {
  title: string;
  status?: RecordTaskStatus;
}

@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrl: './task-details.component.less',
  standalone: false
})
export class TaskDetailsComponent implements OnInit {

  // Public
  public task!: RecordTask;
  public serverId!: string;
  public needs: TaskNeed[] = [];
  public bodyText = '';

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<TaskDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { task: RecordTask; serverId: string; needs?: TaskNeed[] },
    private recordsService: RecordsService,
    private notificationService: NotificationService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    // Work on a copy so edits aren't reflected on the board until saved
    this.task = { ...this.data.task };
    this.serverId = this.data.serverId;
    this.needs = this.data.needs || [];
    this.bodyText = JSON.stringify(this.task.body ?? {}, null, 2);
  }

  /**
   * Actions
   */

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    let body: any;
    try {
      body = this.bodyText.trim().length ? JSON.parse(this.bodyText) : undefined;
    } catch (error: any) {
      this.notificationService.error('Update Task Error:', (error as SyntaxError).message, true);
      return;
    }
    const updated: RecordTask = { ...this.task, body };
    this.recordsService.updateTask(this.serverId, updated)
      .subscribe(result => {
        if (result) {
          this.dialogRef.close(updated);
        }
      });
  }

}
